import * as React from 'react';
import { IconPercent16, IconBullet16, IconMilitaryMortgage16, IconFavoriteOn16, IconMortgage16 } from '@cian/ui-kit';
import { EPromoType } from '../repositories/newbuilding-card/entities/promo/PromoInfoSchema';

export const MORTGAGE_PROMO_TYPES = [EPromoType.Mortgage, EPromoType.Bank, EPromoType.CianMortgage];

export type TIconColor = 'E84260' | 'FF9D00' | '2E9E00';
export type TIconType = typeof IconMortgage16 | typeof IconPercent16 | typeof IconFavoriteOn16;
export type TIconTypeClass = 'discount' | 'mortgage' | 'bonus';
export type TIconClassName = 'promoIconDiscount' | 'promoIconMortgage' | 'promoIconBonus';

export interface IIconStyle {
  iconColor: TIconColor;
  iconType: TIconType;
  iconTypeClass: TIconTypeClass;
  iconClassName: TIconClassName;
}
export const QUANTITY_PROMOS_IN_ROW = 2;
export const PROMO_TYPES_MAP: { [index: string]: IIconStyle } = {
  bank: {
    iconColor: 'E84260',
    iconType: IconPercent16,
    iconTypeClass: 'discount',
    iconClassName: 'promoIconDiscount',
  },
  discount: {
    iconColor: 'E84260',
    iconType: IconPercent16,
    iconTypeClass: 'discount',
    iconClassName: 'promoIconDiscount',
  },
  mortgage: {
    iconColor: 'FF9D00',
    iconType: IconMortgage16,
    iconTypeClass: 'mortgage',
    iconClassName: 'promoIconMortgage',
  },
  bonus: {
    iconColor: '2E9E00',
    iconType: IconFavoriteOn16,
    iconTypeClass: 'bonus',
    iconClassName: 'promoIconBonus',
  },
};

export const BANK_ICON_MAP: { [key: string]: React.ReactNode } = {
  [EPromoType.MaternalCapital]: <IconBullet16 color="gray_icons_100" />,
  [EPromoType.MilitaryMortgage]: <IconMilitaryMortgage16 color="success_100" />,
};
